import React from "react";
import styles from "./PrivacyPolicy.module.css";

const PrivacyPolicy = () => {
  return (
    <div className={styles.policyContainer}>
      <h1>Privacy Policy</h1>

      <p>
        This Privacy Policy (“Policy”) describes how Charles Technologies Private
        Limited (“SS Media”, “We”, “Us”, or “Our”) collects, uses, and protects
        information of users (“You”, “Your”) who access or use the SS Media mobile
        application (“App”) and related services.
      </p>

      <p>
        By accessing or using the App, You agree to this Policy. If You do not
        agree, please uninstall the App and discontinue use immediately.
      </p>

      <h2>A. SCOPE</h2>
      <p>
        This Policy applies to all users of the SS Media App, which provides news
        articles, trending stories, and video content linked from our official YouTube
        channel. This Policy does not apply to third-party websites, apps, or content
        that may be accessed via external links within the App.
      </p>

      <h2>B. INFORMATION WE COLLECT</h2>
      <p>We collect only the minimal information necessary to operate and improve the App.</p>

      <h3>1. Information You Provide</h3>
      <ul>
        <li>Mobile Number: Required to log in via OTP for secure access.</li>
        <li>Name and Photo: Optional, collected if you choose to update your Profile section.</li>
        <li>Feedback Details: Information You submit through the in-app Feedback form.</li>
      </ul>

      <h3>2. Automatically Collected Information</h3>
      <ul>
        <li>Device type, operating system, and version.</li>
        <li>App version and basic usage statistics (e.g., screens viewed, time spent).</li>
      </ul>

      <p>
        <strong>Note:</strong> We do not collect precise location data, contact lists,
        or personal identifiers other than those listed above.
      </p>

      <h2>C. DEVICE PERMISSIONS</h2>
      <p>
      <h3>Camera and Storage Access</h3>
To enhance your profile experience, our app requests access to your device’s camera and storage. This allows you to: <br />
Capture and upload a profile picture directly from your camera. <br />
Select and upload an existing image from your device’s gallery. <br />
We only access these features with your permission and do not store or use your media without your consent.
      </p>

      <h2>D. ACCOUNT DELETION POLICY</h2>
      <p>To delete your SS Media account:</p>
      <ul>
        <li>Go to the Profile section and tap <strong>Delete Account</strong></li>
        <li>
          Or email us at{" "}
          <a href="mailto:developercharlestech@gmail.com">
            developercharlestech@gmail.com
          </a>{" "}
          with your registered mobile number and subject: <strong>Account Deletion Request</strong>.
        </li>
      </ul>
      <p>
        Requests will be processed within 7 business days. Minimal records may be
        retained for up to 90 days for legal or security reasons.
      </p>

      <h2>E. USE OF INFORMATION</h2>
      <ul>
        <li>To authenticate your login using OTP verification.</li>
        <li>To display your name and picture under your Profile (if provided).</li>
        <li>To improve the App experience and maintain performance.</li>
        <li>To respond to feedback or support requests.</li>
        <li>
          To analyze non-identifiable usage trends for improving user experience.
        </li>
      </ul>

      <p>
        We do <strong>not</strong> use your data for advertising, marketing, profiling,
        or sharing with third-party ad networks.
      </p>

      <h2>F. REPORTING AND ACCOUNTABILITY</h2>
     <p>
      Users can report any content published by SS Media or any comment posted by other individuals using the Feedback option available in the Right Menu.
Reports will be reviewed within 24 hours, and objectionable content will be removed promptly.
<p>Any user who posts objectionable comments shall be held accountable and may face suspension or termination of their account.</p>
     </p>

      <h2>G. VIDEO CONTENT AND EXTERNAL LINKS</h2>
      <p>
        Videos shown in the App are linked from YouTube. YouTube may collect data
        independently under its own Privacy Policy. SS Media does not store this data.
      </p>

      <p>
        External links follow the terms and policies of the respective third-party platforms.
      </p>

      <h2>H. DATA SHARING AND DISCLOSURE</h2>
      <p>We do not sell, rent, or share Your personal data with advertisers.</p>

      <p>Data may be disclosed only:</p>
      <ul>
        <li>To comply with legal obligations or law enforcement requests.</li>
        <li>
          To service providers assisting in App hosting or SMS delivery (OTP), bound by confidentiality.
        </li>
      </ul>

      <h2>I. DATA RETENTION</h2>
      <p>
       Your mobile number and profile details (such as your name) are retained by SS Media for the duration of your use of the App and will remain stored even if you uninstall the App.
      </p>

      <p>
Feedback or analytical information may be stored in an aggregated or anonymized form to help us improve App performance, user experience, and service quality. Such data will not identify you personally.      </p>

      <h2>J. SECURITY</h2>
      <ul>
        <li>OTP-based secure login</li>
        <li>Encrypted data transmission (HTTPS)</li>
        <li>Restricted internal access</li>
      </ul>

      <p>
        However, no electronic system is 100% secure, and absolute data protection
        cannot be guaranteed.
      </p>

      <h2>K. CHILDREN’S PRIVACY</h2>
      <p>
        The App is intended for general public use and does not target or knowingly collect personal information from minors. No age restriction or sensitive data collection applies.
      </p>

      <h2>L. YOUR RIGHTS</h2>
      <p>You may:</p>
      <ul>
        <li>Access or review your information.</li>
        <li>Request correction of your data.</li>
        <li>Withdraw consent by uninstalling the App.</li>
      </ul>

      <p>
        Requests related to data access or deletion can be sent to{" "}
        <a href="mailto:developercharlestech@gmail.com">
          developercharlestech@gmail.com
        </a>.
      </p>

      <h2>M. CHANGES TO THIS POLICY</h2>
      <p>
       We may update this Policy periodically to reflect operational, legal, or regulatory changes. Updated versions will be published within the App and on our website at {" "}. The “Last Updated” date below indicates the most recent revision
        <a href="https://ssmedia.app" target="_blank" rel="noreferrer">
          https://ssmedia.app
        </a>
        .
      </p>

      <h2>N. CONTACT US</h2>
      <p>
        📧{" "}
        <a href="mailto:developercharlestech@gmail.com">
          developercharlestech@gmail.com
        </a>
        <br />
        🏢 Charles Technologies Private Limited, Chennai, Tamil Nadu, India
      </p>

      <p className={styles.lastUpdated}>Last Updated: November 2025</p>
    </div>
  );
};

export default PrivacyPolicy;
